export default "__VITE_ASSET__aaea01d7__"